import { render } from "./eb-select.vue?vue&type=template&id=0d22977e&scoped=true"
import script from "./eb-select.vue?vue&type=script&lang=ts"
export * from "./eb-select.vue?vue&type=script&lang=ts"

import "./eb-select.vue?vue&type=style&index=0&id=0d22977e&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-0d22977e"

export default script